import React, { startTransition } from 'react';
import { SessionContext } from '@benzinga/session-context';
import { DelayedQuote, QuotesManager } from '@benzinga/quotes-manager';

export interface CryptoQuote {
  change: number;
  changePercent: number;
  dayHigh: number;
  dayLow: number;
  marketCap: string | number;
  name: string;
  price: number;
  symbol: string;
  volume: number;
}

export interface UseTickerDataResult {
  stockQuote?: DelayedQuote | undefined;
  cryptoQuote?: CryptoQuote | undefined;
}

export const useTickerData = (symbol: string): UseTickerDataResult => {
  const session = React.useContext(SessionContext);
  const [stockQuote, setStockQuote] = React.useState<DelayedQuote>();

  const quotesManager = session.getManager(QuotesManager);

  React.useEffect(() => {
    quotesManager.addSymbolSubscription(symbol);

    const initialQuote = quotesManager.getQuoteFromSubscriptionStore(symbol);
    if (initialQuote) {
      startTransition(() => setStockQuote(initialQuote));
    }

    const subscription = quotesManager.subscribe(event => {
      if (event.type === 'quote:delayed_quote_update' && event.symbol === symbol) {
        startTransition(() => setStockQuote(event.quote));
      }
    });

    return () => {
      subscription?.unsubscribe();
      quotesManager.removeSymbolSubscription(symbol);
    };
  }, [symbol, quotesManager]);

  return { stockQuote };
};
